import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export const archiveFeatured = () => {

	let els = document.querySelectorAll('[data-animation="archive-featured"]')

	if (!els.length || window.innerWidth < 960) return

	els.forEach(el => {
		ScrollTrigger.create({
			trigger: el,
			endTrigger: el.parentElement,
			pin: true,
			start: 'top top',
			end: 'bottom bottom',
			// markers: true,
		});
	})
}

export default () => { }